import APIService from './apiservice';

const ROUTE = 'api/v1/ai-console';

const aiConsoleService = {
	getObservability: () => APIService.doRequest(`${ROUTE}/observability`, 'GET'),
	getSettings: () => APIService.doRequest(`${ROUTE}/settings`, 'GET'),
	recompileKb: () => APIService.doRequest(`${ROUTE}/recompile-kb`, 'POST', {}),
	getAgents: () => APIService.doRequest(`${ROUTE}/agents`, 'GET'),
	getAgent: (key) => APIService.doRequest(`${ROUTE}/agents/${key}`, 'GET'),
	updateAgentRole: (key, body) => APIService.doRequest(`${ROUTE}/agents/${key}/role`, 'PUT', body),
	updateAgentSettings: (key, body) => APIService.doRequest(`${ROUTE}/agents/${key}/settings`, 'PUT', body),
	createPromptVersion: (key, body) => APIService.doRequest(`${ROUTE}/agents/${key}/prompt`, 'POST', body),
	setActivePrompt: (key, body) => APIService.doRequest(`${ROUTE}/agents/${key}/prompt/active`, 'PUT', body),
	runAgentEval: (key) => APIService.doRequest(`${ROUTE}/agents/${key}/eval`, 'POST', {}),
	getAgentHistory: (key) => APIService.doRequest(`${ROUTE}/agents/${key}/history`, 'GET'),
	getAudit: () => APIService.doRequest(`${ROUTE}/audit`, 'GET'),
};

export default aiConsoleService;
